import axios from 'axios';

const CreditReportTradelineService = {
  async deleteCreditReportTradeline(id) {
    const response = await axios.delete(`/credit-report-tradelines/${id}`);

    return response.data;
  },

  async updateCreditReportTradeline({ formValues, id }) {
    const response = await axios.patch(
      `/credit-report-tradelines/${id}`,
      formValues
    );

    return response.data;
  },
};

export default CreditReportTradelineService;
